
export const ADD_QRCODE_INFO = 'ADD_QRCODE_INFO'; // 添加二维码配置

export const GET_QRCODE_LIST = 'GET_QRCODE_LIST'; // 获取二维码列表

export const DELETE_QRCODE = 'DELETE_QRCODE'; // 删除二维码
